<script setup lang="tsx">
import type { PasswordLogin } from '@/models/api-generated'
import http from '@/services/http'
import { ref } from 'vue'

const emit = defineEmits(['success'])
const email = ref('')
const password = ref('')
const isBusy = ref(false)

async function login() {
	const request: PasswordLogin | any = {
		email: email.value,
		password: password.value,
	}

	isBusy.value = true
	try {
		const { status } = await http.post('adlogin', request)
		if (status == 200) emit('success')
	} catch {
		// ignore
	}
	isBusy.value = false
}
</script>

<template>
	<div class="row mb-3 text-nowrap">
		<div class="col-md-4 text-start">
			<label for="user-login" class="col-form-label">{{ $t('adUser') }}</label>
		</div>
		<div class="col-md-8">
			<input id="user-login" maxlength="60" class="form-control" v-model="email" @keydown.enter.prevent="login" />
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-4 text-start">
			<label for="user-password" class="col-form-label">{{ $t('password') }}</label>
		</div>
		<div class="col-md-8">
			<input id="user-password" type="password" maxlength="60" class="form-control" v-model="password" @keydown.enter.prevent="login" />
		</div>
	</div>
	<div class="row">
		<div class="col">
			<button id="adlogin-btn" class="btn btn-primary w-100" :disabled="isBusy" @click="login">
				<template v-if="isBusy">
					<div class="spinner-border spinner-border-sm"></div>
				</template>
				<template v-else>{{ $t('login') }}</template>
			</button>
		</div>
	</div>
</template>

<style lang="sass" scoped></style>
